export function showAlert(message, state) {
        const alertBox = document.querySelector('.custom-alert');
        alertBox.classList.remove('success', 'error');
        const alertContent = alertBox.querySelector('.custom-alert-content');
        const alertHead = alertBox.querySelector('.custom-alert-head-text');
        const progressBar = alertBox.querySelector('.custom-alert-progress');

        alertContent.innerText = message;

        if (state === "success") {
            alertHead.innerText = "Erfolgreich";
            console.log('UI Success:', message);
        }
        if (state === "error") {
            alertHead.innerText = "Fehler";
            console.error('UI Error:', message);
        }

        alertBox.classList.add('show', state);
        let progressInterval;
        let alertTimeout;
        // Progressbar manuell hochzählen
        if (progressBar) {
            let progress = 0;
            progressBar.style.width = '0%';

            clearInterval(progressInterval);
            progressInterval = setInterval(() => {
            progress += 1;
            progressBar.style.width = `${progress}%`;

            if (progress >= 100) {
                clearInterval(progressInterval);
            }
            }, 100); // 100ms × 100 = 10 Sekunden
        }

        // Auto-close nach 10 Sekunden
        clearTimeout(alertTimeout);
        alertTimeout = setTimeout(() => {
            alertBox.classList.remove('show');
            if (progressBar) {
                progressBar.style.width = '0%';
            }
        }, 10000);
    }

/**
 * Präferenz "Pflanzenvielfalt".
 * Sie filtert die Gerichteliste NICHT, sondern steuert die Auswahl der Automatik.
 * Solange die Konstante leer ist, verhält sich das Quiz wie bisher.
 */
export const PLANT_VARIETY_PREFERENCE_ID = "719656419703"; // <-- Metaobjekt-ID eintragen, NACH dem ersten Deploy
export const PLANT_VARIETY_TARGET = 30;

/**
 * Liest die Pflanzenliste aus dem data-plants-Attribut einer Produktkarte.
 */
export function readPlants(productElement) {
  return (productElement?.dataset?.plants || "")
    .split(",")
    .map((p) => p.trim())
    .filter(Boolean);
}

/**
 * Sortiert Produktkarten so, dass jede nächste Karte möglichst viele NEUE
 * Pflanzen beisteuert (Greedy Set Cover).
 *
 * Rückgabe ist eine Reihenfolge, keine Auswahl — fillAuto() nimmt davon
 * die ersten maxCount Karten.
 *
 * @param {HTMLElement[]} products    verfügbare Produktkarten
 * @param {Set<string>}   coveredInit Pflanzen, die schon in der Box liegen
 */
export function orderByPlantGain(products, coveredInit = new Set()) {
  const covered = new Set(coveredInit);
  const pool = [...products];
  const ordered = [];

  while (pool.length > 0) {
    let bestIndex = 0;
    let bestGain = -1;
    let bestSize = -1;

    for (let i = 0; i < pool.length; i++) {
      const plants = readPlants(pool[i]);
      let gain = 0;
      for (const p of plants) {
        if (!covered.has(p)) gain++;
      }

      // Gleichstand: das Gericht mit mehr Pflanzen gewinnt,
      // danach entscheidet der Zufall — sonst bekämen alle Kunden dieselbe Box.
      const better =
        gain > bestGain ||
        (gain === bestGain && plants.length > bestSize) ||
        (gain === bestGain && plants.length === bestSize && Math.random() < 0.5);

      if (better) {
        bestGain = gain;
        bestSize = plants.length;
        bestIndex = i;
      }
    }

    const chosen = pool.splice(bestIndex, 1)[0];
    readPlants(chosen).forEach((p) => covered.add(p));
    ordered.push(chosen);
  }

  return ordered;
}